import React, { useState } from 'react';
import { Hero } from './Hero';
import { About } from './About';
import { Products } from './Products';
import { Capacity } from './Capacity';
import { Quality } from './Quality';
import { Gallery } from './Gallery';
import { Contact } from './Contact';

export const DesktopTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div className="min-h-screen pt-20">
      {/* Tab Content - Only show active tab */}
      <div className="animate-in fade-in duration-300">
        {activeTab === 'inicio' && (
          <div>
            <Hero />
            <About />
          </div>
        )}
        {activeTab === 'productos' && <Products />}
        {activeTab === 'capacidad' && <Capacity />}
        {activeTab === 'calidad' && <Quality />}
        {activeTab === 'galeria' && <Gallery />}
        {activeTab === 'contacto' && <Contact />}
      </div>
    </div>
  );
};
